import React from "react";
import { getFormattedNumber, getYearFromDateStr } from "../utils/textUtils";

const ItemPriceList = ({ resPacket, loading }) => {
  const getTotalAmount = (row) => {
    const { amount, taxAmt, discount } = row;
    const _amount = parseFloat(amount);
    const _taxAmt = parseFloat(taxAmt);
    const _discount = parseFloat(discount);
    const total = _amount + _taxAmt - _discount;
    return getFormattedNumber(total);
  };

  if (resPacket?.length === 0) {
    return "No Records Found";
  }

  return (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>YEAR</td>
            <td>MONTH</td>
            <td>INVOICE DATE</td>
            <td>INV NO</td>
            <td>VEHICLE NUMBER</td>
            <td>CUSTOMER NAME</td>
            <td>CUSTOMER CATEGORY</td>
            <td>CITY</td>
            <td>STATE</td>
            <td>BATCH NO.</td>
            <td>MFG DATE</td>
            <td>EXPIRY DATE</td>
            <td>ITEM CODE</td>
            <td>ITEM DESC./NAME</td>
            <td>ITEM CATEGORY</td>
            <td>ITEM SUB CATEGORY</td>
            <td>QTY ORDER</td>
            <td>ORDER UOM</td>
            <td className="text-center">DISPATCHED QTY</td>
            <td> SOLD UOM</td>
            <td>ALT QTY</td>
            <td className="text-center">ITEM RATE</td>
            <td className="text-center">AMOUNT</td>
            <td className="text-center">DISCOUNT</td>
            <td className="text-center">TAX RATE</td>
            <td className="text-center">TOTAL AMOUNT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket.map((row, i) => (
            <tr key={i}>
              <td>{i+1}</td>
              <td>
                <small>
                  {row.invoiceDate && getYearFromDateStr(row.invoiceDate)[0]}
                </small>
              </td>
              <td>
                <small>
                  {row.invoiceDate && getYearFromDateStr(row.invoiceDate)[1]}
                </small>
              </td>
              <td>
                <small className="white-space-pre">{row.invoiceDate}</small>
              </td>
              <td>
                <small className="white-space-pre">{row.invoiceNo}</small>
              </td>
              <td>
                <small>{row.vehicleNo}</small>
              </td>
              <td>
                <small>{row.customerName}</small>
              </td>
              <td>
                <small>{row.customerCategory}</small>
              </td>
              <td>
                <small>{row.city}</small>
              </td>
              <td>
                <small>{row.state}</small>
              </td>
              <td>
                <small>{row.batchNo}</small>
              </td>
              <td>
                <small>{row.mfgDate}</small>
              </td>
              <td>
                <small>{row.expDate}</small>
              </td>
              <td>
                <small>{row.itemCode}</small>
              </td>
              <td>
                <small>{row.itemName}</small>
              </td>
              <td>
                <small>{row.category}</small>
              </td>
              <td>
                <small>{row.subCategory}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.salesOrderQty)}</small>
              </td>
              <td>
                <small>{row.salesOrderUnit}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.qty)}</small>
              </td>
              <td>
                <small>{row.uom}</small>
              </td>
              {/* <td className='text-right'><small>{getFormattedNumber(row.salesOrderUnit)}</small></td> */}
              <td>
                <small className="white-pre">{row.altQty}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.rate)}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.amount)}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.discount)}</small>
              </td>
              <td className="text-right">
                <small>{getFormattedNumber(row.taxRate)}</small>
              </td>
              <td className="text-right">
                <small>{getTotalAmount(row)}</small>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ItemPriceList;
